<template>
    <v-tab-item :value="PREVIEW.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">프리뷰</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">프리뷰의 성격</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>프리뷰는 경매에 출품된 모든 작품을 감상하고 상태를 확인할 수 있는 전시회입니다.</span></li>
                                    <li><em>-</em><span>프리뷰 관람은 경매 응찰과 관계없이 누구나 무료로 관람이 가능합니다.</span></li>
                                    <li><em>-</em><span>프리뷰를 통하여, 작품의 양적 가치와 질적 가치를 새롭게 발견하실 수 있습니다.</span></li>
                                    <li><em>-</em><span>당사의 경매는, 여러분들이 프리뷰를 통해 작품의 실물을 확인하였음을 전제로 진행합니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">상태검사 권유 및 보증</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>프리뷰 전시에서, 작품의 상태를 충분히 확인하신 후에 응찰하시길 권유합니다.</span></li>
                                    <li><em>-</em><span>당사의 경매작품은, 별도의 보수(수리)나 처치없이, 위탁받은 작품 상태 그대로 출품합니다.</span></li>
                                    <li><em>-</em><span>작품보증 시점 : 경매되는 시점을 기준으로 합니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">경매작품 안내</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>프리뷰 전시장에서, 작품안내를 요청하시면, 경매작품에 대한 자세한 안내를 받으실 수 있습니다.</span></li>
                                    <li><em>-</em><span>모바일 홈페이지에서, 작품별로 물리적, 논리적 세부 정보 사항을 확인하실 수 있습니다. </span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">프리뷰 일정 및 장소</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>일정 공지 : 프리뷰 일정은 문자, SNS, 홈페이지 등을 통해 공지 됩니다.</span></li>
                                    <li><em>-</em><span>전시 장소 : 갤러리라온 (서울시 종로구 부암동 185-6)</span></li>
                                    <li><em>-</em><span>운영 시간 : 10am ~ 6pm</span></li>
                                    <li><em>-</em><span>문의 : 02-395-6987</span></li>
                                </ul>
                            </div>

                            <v-divider class="grey-cb my-30 my-md-36"></v-divider>

                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Characteristics of Preview</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Preview is an exhibition where you can view and check the condition of all works exhibited for auction.</span></li>
                                    <li><em>-</em><span>Anyone can watch the preview exhibition for free, regardless of whether they bid or not.</span></li>
                                    <li><em>-</em><span>Through the preview, you can discover new quantitative and qualitative values of the work.</span></li>
                                    <li><em>-</em><span>The auction proceed with based on check the real objects(works) through the preview show</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Condition Inspection and Guarantee</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>We recommend that you bid after thoroughly checking the condition of the works In the preview exhibition.</span></li>
                                    <li><em>-</em><span>Our auction works are exhibited in the condition they were entrusted with, without any additional repair or treatment.</span></li>
                                    <li><em>-</em><span>We ensure the conditions of the works from the point we presented items on the auction.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Information on Auction Artwork</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>If you request information about the works at the exhibition hall, you can receive detailed information</span></li>
                                    <li><em>-</em><span>On the mobile homepage, you can check the physical and logical information(Description) on the each work.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Preview schedule and location</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Schedule Notice: Preview schedule will be announced through text message, SNS, website, etc.</span></li>
                                    <li><em>-</em><span>Exhibition Location : Gallery Raon (185-6 Buam-dong, Jongno-gu, Seoul)</span></li>
                                    <li><em>-</em><span>Operating Hours: 10am-6pm</span></li>
                                    <li><em>-</em><span>Inquiries: 02-395-6987</span></li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { PREVIEW } = HOW_TO_BID_TABS;
export default {
    data() {
        return {
            PREVIEW,
        };
    },
};
</script>

<style></style>
